import React from "react";
import { Typography, TextField } from "@material-ui/core";
import useTranslatedValue from "../../../../hooks/useTranslatedValue";
import useAnswerQuestion from "../../hooks/useAnswerQuestion";
import { decialRegex } from "../../utils/questionRegex";
import useQuestionStyles from "./questionStyles";

export const DecimalQuestion = ({ question, isDisabled, followUpUUID }) => {
    const classes = useQuestionStyles();
    const getTranslatedValue = useTranslatedValue();
    const answerQuestion = useAnswerQuestion();

    const min = question.props?.min !== undefined && question.props?.min !== "" ? Number(question.props.min) : undefined;
    const max = question.props?.max !== undefined && question.props?.max !== "" ? Number(question.props.max) : undefined;

    const handleChange = (e) => {
        const value = e.target.value;
        if (value === "" || decialRegex.test(value)) {
            if (value === "" || (Number(value) >= min && Number(value) <= max)) {
                answerQuestion(value, question, followUpUUID);
            }
        }
    };

    return (
        <>
            <Typography variant="body1" className={classes.questionText}>
                {question.mandatory && <span className={classes.mandatory}>*</span>}
                {getTranslatedValue(question.questionText)}
            </Typography>
            <TextField
                fullWidth
                variant="outlined"
                name={question.name}
                value={question.value ?? ""}
                onChange={handleChange}
                disabled={isDisabled || question.isDisabled}
                required={question.mandatory}
                inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9]*[.,]?[0-9]*",
                    min: min,
                    max: max,
                }}
                label={getTranslatedValue(question.tooltip)}
                InputProps={{
                    className: classes.input,
                }}
                InputLabelProps={{
                    className: classes.inputLabel,
                }}
            />
        </>
    );
};
export default DecimalQuestion;
